import { node } from 'prop-types';
import React from 'react';

export default function FooterItem({ children }) {
    return (<div
        className={'footer-item'}>
        <div
            className={'footer-item-blocks'}>
            {children}
        </div>
    </div>);
}

FooterItem.propTypes = {
    children: node,
};